
import styled from "styled-components";
import PricingPlans from "../components/PricingComponents/PricingPlans";
import PricingFaq from "../components/PricingComponents/PricingFaq";
import TrackingComponent from "../components/Tracking/TrackingComponent";
import CalculateCost from "../components/PricingComponents/CalculateCost";
import ComparePlans from "../components/PricingComponents/ComparePlans";
import GrovsDeliver from "../components/Marketing/GrovsDeliver";
import { Helmet } from "react-helmet-async";
import GetStartedRequestDemoSide from "../components/generic/GetStartedRequestDemoSide";
import { lightThemeColors } from "../assets/style/colors";
import { ReactComponent as GridAssetIcon } from "../assets/decorations/blueBannerGrid.svg";

const PricingPage = () => {
  return (
    <>
      <Helmet>
        <title>Pricing Plans for Deep Linking & User Engagement | Grovs</title>
        <meta
          name="description"
          content="Explore Grovs pricing plans designed for personal use, startups, growing teams, and enterprises. Benefit from deep linking, attribution, referrals, marketing messages, and more."
        />
        <meta
          name="keywords"
          content="Grovs pricing, app growth pricing, deep linking pricing, user engagement pricing, marketing message pricing, attribution pricing, SaaS pricing plans"
        />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Grovs Pricing — Deep Linking & Engagement Plans"
        />
        <meta
          property="og:description"
          content="Choose from Free, Scale Up, and Enterprise plans with features like unlimited links, deferred deep linking, marketing messages, and more."
        />
        <meta property="og:url" content="https://www.grovs.io/pricing" />
        <meta
          property="og:image"
          content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/pricing-social.jpg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Grovs Pricing — Deep Linking & Engagement Plans"
        />
        <meta
          name="twitter:description"
          content="Flexible pricing for personal use, teams, and enterprises. Deep linking, marketing messaging, analytics, and more."
        />
        <meta
          name="twitter:image"
          content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/pricing-social.jpg"
        />
      </Helmet>

      <Container>
        <PricingPlans />
        <CalculateCost />
        <ComparePlans />
        <PricingFaq />
        {/* <GrovsFeature /> */}
        <GrovsDeliver />
        <GetStartedRequestDemoSide
          bgColor={lightThemeColors.measureBg}
          gradientColor={"rgba(91, 104, 223, 1)"}
          titleStyle={{ color: lightThemeColors.lightColor }}
          subtitleStyle={{ color: lightThemeColors.lightColorFaded7 }}
          gridDecoration={<GridAssetIcon />}
          primaryButtonStyle={{ color: lightThemeColors.lightColor }}
          primaryButtonVariant={lightThemeColors.footerBg}
          outlineButtonStyle={{
            color: lightThemeColors.darkColor,
            background: lightThemeColors.lightColor,
          }}
          outlineButtonVariant={lightThemeColors.lightColor}
          title={" Are you ready to boost your app's growth?"}
          subtitle={"Create a free account - no card required."}
        />
        <TrackingComponent></TrackingComponent>
      </Container>
    </>
  );
};

export default PricingPage;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
